
export const environment = {
    //API_URL: 'https://lab.padraocolor.com', //HOMOLOG
    API_URL: 'https://lord.padraocolor.com', // PROD
    //MARKETPLACE_API_URL: 'http://localhost:3000', // DEV
    MARKETPLACE_API_URL: 'https://marketplace-api-patient-grass-5062.fly.dev', // PROD
    API_KEY_MARKETPLACE: 'SUA_CHAVE_SECRETA_SUPER_FORTE_AQUI', // DEV
    API_TOKEN_DEFAULT: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjb2RpZ28iOjU3NX0.EbOdmP4T6j3exdk8YiLKG_86StglUm4OXQYqPawtaVo',
    API_TOKEN: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjb2RpZ28iOjU3NX0.EbOdmP4T6j3exdk8YiLKG_86StglUm4OXQYqPawtaVo'
}